var _radialGradient, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSpinnericon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  ref: ref
}, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
  id: "a12",
  cx: 0.66,
  fx: 0.66,
  cy: 0.3125,
  fy: 0.3125,
  gradientTransform: "scale(1.5)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "currentColor"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "currentColor",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "currentColor",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "currentColor",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "transform-origin": "center",
  fill: "none",
  stroke: "url(#a12)",
  strokeLinecap: "round",
  strokeDasharray: "200 1000",
  strokeDashoffset: 0,
  strokeWidth: 24,
  cx: 100,
  cy: 100,
  r: 70
}, /*#__PURE__*/React.createElement("animateTransform", {
  type: "rotate",
  attributeName: "transform",
  calcMode: "spline",
  dur: 2,
  values: "360;0",
  keyTimes: "0;1",
  keySplines: "0 0 1 1",
  repeatCount: "indefinite"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  transformOrigin: "center",
  fill: "none",
  opacity: 0.2,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 24,
  cx: 100,
  cy: 100,
  r: 70
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinnericon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;